import './css/styles.scss';

function initFotter() {
	const footerNav = document.querySelector('[data-footer-nav]');
	if (!footerNav) return;

	//const toggleBtns = footerNav.querySelectorAll('.toggle-button');
	//if (!toggleBtns) return;


	//const menuItems = footerNav.querySelectorAll('.menu-item-has-children');
	// only the the li that has this classname not it children
	const menuItems = footerNav.querySelectorAll('.menu-item-has-children > a');


	menuItems.forEach((menuItem) => {
		//const toggleBtn = menuItem.querySelector('a');
		// toogleBtn is the li.menu-item-has-children
		const toggleBtn = menuItem;
		const subMenu = menuItem.querySelector('.sub-menu');

		toggleBtn.addEventListener('click', (event) => {

			event.preventDefault();
			console.log('clicked');
			// add class open on the cliked menu item
			//menuItem.classList.toggle('openDropdown');
			// add class open on the parent li
			menuItem.parentElement.classList.toggle('openDropdown');
	
		}, false);
	});
}

// on document ready
document.addEventListener('DOMContentLoaded', () => {
	initFotter();
});
